import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetRequestProtocolPdf,
	GetRequestProtocolPdfParams,
	GetRequestProtocolPdfResponse,
} from 'domain/usecases';

export class RemoteGetRequestProtocolPdf implements GetRequestProtocolPdf {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRequestProtocolPdfResponse>,
	) {}

	async get(params: GetRequestProtocolPdfParams): Promise<GetRequestProtocolPdfResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
